export default __webpack_public_path__ + "static/media/tokenImagePomelo.a55e0580.svg";